import { render } from "./UserOverview.vue?vue&type=template&id=1b848300&scoped=true&ts=true"
import script from "./UserOverview.vue?vue&type=script&lang=ts"
export * from "./UserOverview.vue?vue&type=script&lang=ts"

import "./UserOverview.vue?vue&type=style&index=0&id=1b848300&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b848300"]])

export default __exports__